import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useMediaQuery } from "react-responsive";
import { useHistory, useLocation } from "react-router-dom";

import { GoBackButton } from "pages/buyers/components/goBackButton";
import { StyledContainer } from "./styles";
import { AllClientHeader } from "./components/AllClientHeader";
import { AllPendingPpcTable } from "./components/allPendingPpcTable";
import { serviceProviderPpcListSelector } from "data/selectors/serviceProvider";
import { getServiceProviderPpcListOfAllClient } from "data/actions/serviceProvider";

const ViewAllPpcPage = () => {
  const isMobile = useMediaQuery({ maxWidth: 453 });
  let history = useHistory();
  const location = useLocation();
  const section = location.state?.section || "";

  const [query, setQuery] = useState("");
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [internalSearchResults, setInternalSearchResults] = useState(data);

  const allContractorPpcData = useSelector(serviceProviderPpcListSelector);

  useEffect(() => {
    if (allContractorPpcData?.length < 1) {
      dispatch(getServiceProviderPpcListOfAllClient());
    }
  }, []);

  useEffect(() => {
    if (allContractorPpcData?.length > 0) {
      let separatedPPCs = [];

      allContractorPpcData.forEach((institution) => {
        const { institutionId, institutionName, projects } = institution;

        projects.forEach((project) => {
          const { projectId, projectName, ppcs } = project;

          ppcs.forEach((ppc) => {
            separatedPPCs.push({
              ...ppc,
              projectId,
              projectName,
              institutionId,
              institutionName,
            });
          });
        });
      });
      setData(separatedPPCs);
    }
  }, [allContractorPpcData]);
  const handleGoBack = () => {
    history.push("/");
  };
  return (
    <StyledContainer isMobile={isMobile}>
      <GoBackButton />
      <AllClientHeader
        title="Progress Payment Certificates"
        hasButton={false}
        subTitle="PPC created in last 90 days"
        // handleButton={handleStartNew}
        setInternalSearchResults={setInternalSearchResults}
        query={query}
        setQuery={setQuery}
        data={data}
        marginBottom="0"
        marginTop="0"
      />
      {data && data.length > 0 && (
        <AllPendingPpcTable
          data={query && query !== "" ? internalSearchResults : data}
          setData={setData}
          selectTab={section}
        />
      )}
      {data.length <= 0 && (
        <div
          style={{
            height: "50%",
            display: "flex",
            fontSize: "18px",
            // textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p>No PPCs found</p>
        </div>
      )}
    </StyledContainer>
  );
};

export default ViewAllPpcPage;
